import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useApi } from "/src/helpers/Hooks/useApi.jsx";
import Navigation from "/src/helpers/components/navigation.jsx";
import { setBooking, track } from "/src/helpers/analytics";


export default function BookingPageWrapper() {
  var api = useApi();
  const navigate = useNavigate();
  const [model, setModel] = useState();

  const refreshModel = async () => {
    const postsData = await api.getBooking();
    setModel(postsData);
    if (postsData?.bookingReference) {
      setBooking(postsData.bookingReference, {
        status: postsData.status, daysToDeparture: postsData.daysTillStart,
        destination: postsData.destinationName || postsData.resortName || undefined,
      });
    }
    console.log("MODEL IS ", postsData);
  };

  const handleLogout = async () => {
    await api.logout();
    track("logout");
    setBooking(null);
    setModel(undefined);
    navigate("/login");
  };

  useEffect(() => {
    refreshModel();
  }, []);
  // getBooking() drives the site's loading overlay — nothing else to paint underneath it.
  if (!model) return null;
  return <>
    <Navigation onLogout={handleLogout} authenticationLevel={model.authenticationLevel} bookingReference={model.bookingReference} />
    {/* Full column width — the prototype keeps content the same width as the header/nav. */}
    <div className="w-full pb-10">
      <Outlet context={{ model, refreshModel }} />
    </div>
  </>
};